'use strict';

export class CurrencyConversion {
	constructor() {
		this.wp_nonce_ = wp_nonce_;
	}

	async getConversionRates( currency ) {
		try {
			const headers = new Headers({
				'X-WP-Nonce': this.wp_nonce_
			});
			const response = await fetch(
				window.location.origin + '/wp-json/levcharity/v1/conversions',
				{
					headers:headers
				}
			);

			if ( ! response.ok ) {
				throw new Error(
					'Cannot get data from' +
					window.location.origin +
					'/wp-json/levcharity/v1/conversions'
				);
			}

			const allRates = await response.json();
			return allRates[currency] ?? 0;

		} catch ( error ) {
			console.error( error.message );
			return null;
		}
	}
}
